<template>
  <div id="footer">
    <div class="row">
      <div class="ocean">
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
    </div>

    <!--footer starts from here-->
    <footer class="footer" key="">
    

      <!-- <div class="ghost-box-left pull-left">
        <div class="ghost animate-hover">
          <div class="face">
            <div class="eye eye-left"></div>
            <div class="eye eye-right"></div>
            <div class="mouth animate-smile"></div>
          </div>
          <div class="bottom-container-left">
            <div class="wave"></div>
          </div>
          <div class="bottom-container-right">
            <div class="wave"></div>
          </div>
        </div>
      </div> -->

      <div class="container bottom_border">
        <div class="row">
          <!-- <div class="col-sm-4 col-md col-sm-4 col-12 col">
            <h5 class="headin5_amrc col_white_amrc pt2">Location</h5>
            
            <p class="mb10">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s
            </p>
            <p><i class="fa fa-location-arrow"></i> 9878/25 sec 9 rohini 35</p>
            <p><i class="fa fa-phone"></i> +91-9999878398</p>
            <p><i class="fa fa fa-envelope"></i> info@example.com</p>
          </div> -->

          <div class="col-sm-4 col-md col-6 col">
            <h5 class="headin5_amrc col_white_amrc pt2">Open</h5>
            <!--headin5_amrc-->
            <p class="mb10">
              วันจันทร์ ถึง วันศุกร์ : 8.30น. - 16.30 น. <br />วันเสาร์ อาทิตย์
              : 8.30 น. - 16.30 น.<br />
              <br />
              ยกเว้นวันหยุดนักขัตฤกษ์ และตามประกาศของมหาวิทยาลัย,
              ช่วงสอบทางสำนักจะประกาศให้ทราบต่อไป
            </p>
            <!--footer_ul_amrc ends here-->
          </div>

          <div class="col-sm-4 col-md col-6 col">
            <h5 class="headin5_amrc col_white_amrc pt2">Contact us</h5>
            <!--headin5_amrc-->
            <p>
              ที่อยู่ : เลขที่ 2 ถนนราชธานี ตำบลในเมือง อำเภอเมือง
              จังหวัดอุบลราชธานี <br />อีเมล์ : info.lib@ubru.ac.th
              <br />เวลาติดต่อ : 08.30 น. - 16.30 น. <br />Hotline :
              (045)-352-056 <br />
              line: @ubru-library
            </p>
            <!--footer_ul_amrc ends here-->
          </div>

          <!-- <div class="col-sm-4 col-md col-12 col">
            <h5 class="headin5_amrc col_white_amrc pt2">About us</h5>
            headin5_amrc ends here

            <ul class="footer_ul2_amrc">
              <li>
                <a href="#">
                  <i
                    class="fab fas fa-user-friends fleft padding-right footer-i"
                  ></i>
                  <p>สำหรับเจ้าหน้าที่</p>
                </a>
              </li>
              <li>
                <a href="#"
                  ><i
                    class="fab fas fa-sitemap fleft padding-right footer-i"
                  ></i>
                  <p>แผนผังเว็บไซต์</p>
                </a>
              </li>
            </ul>
            footer_ul2_amrc ends here
          </div> -->
          <!-- halloween -->
          <!-- <div class="ghost-box ">
            <div class="ghost animate-hover">
              <div class="face">
                <div class="eye eye-left"></div>
                <div class="eye eye-right"></div>
                <div class="mouth animate-smile"></div>
              </div>
              <div class="bottom-container-left">
                <div class="wave"></div>
              </div>
              <div class="bottom-container-right">
                <div class="wave"></div>
              </div>
            </div>
          </div> -->
        </div>
        
      </div>

      <div class="container">
        <br />

        <p class="text-center">
          Copyright ©2021 The Office of Academic Resources Ubon Ratchathani
          Rajabhat University, All rights reserved
        </p>

        <ul class="social_footer_ul">
          <li>
            <a
              href="https://www.facebook.com/AcademicResources.UBRU"
              target="_blank"
              ><i class="fab fa-facebook-f"></i
            ></a>
          </li>
          <li>
            <a
              href="https://lib.ubru.ac.th/libintro/index.html"
              target="_blank"
              rel="noopener noreferrer"
              ><i class="fab fa fa-tv"></i
            ></a>
          </li>
          <li>
            <a href="/login-staff" target="_blank">
              <i class="fas fa-users-cog"></i>
            </a>
          </li>
        </ul>
        
        <!--social_footer_ul ends here-->
      </div>
      
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");
.ocean {
  height: 60%;
  width: 100%;
  position: relative;
  bottom: 0;
  left: 0;
  background: #015871;
}
/*footer*/
.col_white_amrc {
  color: rgb(255, 255, 255);
  font-family: "Kanit", sans-serif;
}
footer {
  width: 100%;
  background-color:#BE5504; 
  /*background-color: #c43054;*/
  /* background-color: #000000; */
  /* background-image: url("../../assets/loykrathong/21235651.jpg"); */
  /* background-image: url("../../assets/loykrathong/6460522.jpg");
  background-size: cover; */

  opacity: 0.9;
  min-height: 250px;
  padding: 10px 0px 25px 0px;
  text-align: center;
  font-family: "Kanit", sans-serif;
  bottom: 0;
  position: sticky;
  height: auto;
}
.pt2 {
  padding-top: 40px;
  margin-bottom: 20px;
  text-align: left;
  font-family: "Kanit", sans-serif;
}
i {
  color: #ffffff;
}
footer p {
  font-size: 13px;
  color: rgb(255, 255, 255);
  padding-bottom: 0px;
  margin-bottom: 8px;
  text-align: left;
  font-family: "Kanit", sans-serif;
}
.mb10 {
  padding-bottom: 15px;
}
.footer_ul_amrc {
  margin: 0px;
  list-style-type: none;
  font-size: 14px;
  padding: 0px 0px 10px 0px;
  font-family: "Kanit", sans-serif;
}
.footer_ul_amrc li {
  padding: 0px 0px 5px 0px;
}
.footer_ul_amrc li a {
  color: rgb(255, 255, 255);
  font-family: "Kanit", sans-serif;
}
.footer_ul_amrc li a:hover {
  color: #fff;
  text-decoration: none;
  font-family: "Kanit", sans-serif;
}
.fleft {
  float: left;
}
.padding-right {
  padding-right: 10px;
}

.footer_ul2_amrc {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
  font-family: "Kanit", sans-serif;
}
.footer_ul2_amrc li p {
  display: table;
  font-family: "Kanit", sans-serif;
}
.footer_ul2_amrc li a:hover {
  text-decoration: none;
  font-family: "Kanit", sans-serif;
}
.footer_ul2_amrc li i {
  margin-top: 5px;
}

.bottom_border {
  border-bottom: 1px solid #ffffff;
  padding-bottom: 20px;
  font-family: "Kanit", sans-serif;
}
.foote_bottom_ul_amrc {
  list-style-type: none;
  padding: 0px;
  display: table;
  margin-top: 10px;
  margin-right: auto;
  margin-bottom: 10px;
  margin-left: auto;
  font-family: "Kanit", sans-serif;
}
.foote_bottom_ul_amrc li {
  display: inline;
  font-family: "Kanit", sans-serif;
}
.foote_bottom_ul_amrc li a {
  color: rgb(255, 255, 255);
  margin: 0 12px;
  font-family: "Kanit", sans-serif;
}

.social_footer_ul {
  display: table;
  margin: 15px auto 0 auto;
  list-style-type: none;
  font-family: "Kanit", sans-serif;
}
.social_footer_ul li {
  padding-left: 20px;
  padding-top: 10px;
  float: left;
  font-family: "Kanit", sans-serif;
}
.social_footer_ul li a {
  color: rgb(255, 255, 255);
  /* border: 1px solid rgb(255, 255, 255); */
  padding: 8px;
  border-radius: 50%;
  /* font-family: "Kanit", sans-serif; */
}
.social_footer_ul li i {
  width: 20px;
  height: 20px;
  text-align: center;
}
/* Hallo ween */

.ghost-box {
  padding: 30px 30px 50px 30px;
  margin: 0 auto;
  position: absolute;
  width: 200px;
  transform: scale(0.75);
  transition: 1s all ease-in-out;
  opacity: 0.8;
  cursor: pointer;
  margin-left:1200px;
  top:-50px;
}
.ghost-box:hover {
  opacity: 0.3;
  transform: translate(10%) rotate(2deg) scale(0.85);
}
.ghost-box:hover .mouth.animate-smile {
  -webkit-animation: 0;
  background: #111;
  transform: scale(0.5) translateY(5%);
}
.ghost-box:hover .mouth:before {
  display: none;
}

/* box-left */

.ghost-box-left {
  padding: 30px 30px 50px 30px;
  margin: 0 auto;
  position: absolute;
  width: 250px;
  transform: scale(0.75);
  transition: 1s all ease-in-out;
  opacity: 0.8;
  cursor: pointer;
 
}
.ghost-box-left:hover {
  opacity: 0.3;
  transform: translate(10%) rotate(2deg) scale(0.85);
}
.ghost-box-left:hover .mouth.animate-smile {
  -webkit-animation: 0;
  background: #111;
  transform: scale(0.5) translateY(5%);
}
.ghost-box-left:hover .mouth:before {
  display: none;
}
/**/
.ghost {
  width: 250px;
  height: 300px;
  background: #f8f8ff;
  border-radius: 50% 50% 0 0;
  box-shadow: 0 5px 40px 0px rgba(255, 255, 255, 0.7);
  position: relative;
  opacity: 0.8;
}
.ghost:before,
.ghost:after {
  content: "";
  background: #f8f8ff;
  position: absolute;
  z-index: 10;
  bottom: -17px;
  width: 160px;
  height: 190px;
  border-radius: 18%;
}
.ghost:before {
  left: 3px;
  transform: skew(-34deg) rotate(-23deg);
}
.ghost:after {
  right: 3px;
  transform: skew(34deg) rotate(24deg);
}
.ghost .bottom-container-left,
.ghost .bottom-container-right {
  width: 160px;
  height: 100px;
  overflow: hidden;
  bottom: -90px;
  position: absolute;
  z-index: 20;
}
.ghost .bottom-container-left .wave,
.ghost .bottom-container-right .wave {
  display: block;
  position: relative;
  height: 40px;
  background: #f8f8ff;
}
.ghost .bottom-container-left .wave:before,
.ghost .bottom-container-right .wave:before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100%;
  width: 100%;
  height: 300px;
  background-color: #111;
  right: -25%;
  top: 20px;
}
.ghost .bottom-container-left .wave:after,
.ghost .bottom-container-right .wave:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100%;
  width: 100%;
  height: 300px;
  background-color: #fffbf8;
  left: -25%;
  top: -240px;
}
.ghost .bottom-container-left {
  transform: rotate(180deg) scaleY(-1);
}
.ghost .bottom-container-right {
  right: 0;
}
.ghost .face {
  position: absolute;
  z-index: 20;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 70px;
}
.ghost .face .eye {
  background: #111;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
}
.ghost .face .eye:before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #f8f8ff;
  position: absolute;
  right: 8px;
  top: 6px;
}
.ghost .face .eye.eye-left {
  left: 0;
}
.ghost .face .eye.eye-right {
  right: 0;
}
.ghost .face .mouth {
  background: #111;
  width: 42px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  left: 30%;
  z-index: -1;
  bottom: 0;
}
.ghost .face .mouth:before {
  content: "";
  background: #f8f8ff;
  width: 48px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 6px;
  transition: all 0.3s ease;
}

.animate-hover {
  animation: animate-hover 6s ease-in-out infinite alternate;
}

@keyframes animate-hover {
  0% {
    transform: translatey(0px);
    opacity: 0.8;
  }
  50% {
    transform: translatey(-33px);
    opacity: 1;
    box-shadow: 0 5px 50px 0px white;
  }
  100% {
    transform: translatey(0px);
    opacity: 0.8;
  }
}
</style>
